import { Factory } from 'fishery';
import {
  GetReportsResponse,
  GetReportResponse,
  CreateReportRequest,
  UpdateReportRequest,
} from './ReportServices.types';

export const createReportRequestFactory = Factory.define<CreateReportRequest>(() => {
  return {
    body: {
      columns: [],
      filter: { state: {} },
      name: 'Client Report',
      acl: 'owner',
      category: 'order',
      compoundFilterState: { state: {} },
    },
  };
});

export const updateReportRequestFactory = Factory.define<UpdateReportRequest>(({ sequence }) => {
  return {
    routeParams: {
      reportId: sequence.toString(),
    },
    body: {
      columns: [],
      filter: { state: {} },
      name: 'Client Report',
      acl: 'owner',
    },
  };
});

export const getReportFactory = Factory.define<GetReportResponse>(({ sequence }) => {
  return {
    id: sequence.toString(),
    ownerGuid: '3e05c153-9dcd-49df-8efc-e777ae668f6f',
    ownerAccountGuid: 'da093c5c-85c9-40f0-9ead-813e46190e8c',
    name: 'Hello Report',
    filter: { state: {} },
    columns: ['orderId', 'status', 'lotNumber'],
    acl: 'owner',
    createdByGuid: '3e05c153-9dcd-49df-8efc-e777ae668f6f',
    dateCreated: '2021-08-10T20:00:00.000Z',
    email: '',
    compoundFilterState: { state: {} },
  };
});

export const getReportsFactory = Factory.define<GetReportsResponse, { numberOfReports?: number }>(
  ({ transientParams }) => {
    const length = transientParams.numberOfReports ?? 1;
    return {
      next: false,
      page: 1,
      results: getReportFactory.buildList(length),
      rows: length,
    };
  },
);
